import "core-js/modules/es6.object.assign";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";
import { IconoirContext } from "./IconoirContext";

function SvgBasketballAlt(passedProps, svgRef) {
  var context = React.useContext(IconoirContext);

  var props = __assign(__assign({}, context), passedProps);

  return React.createElement("svg", __assign({
    width: "1.5em",
    height: "1.5em",
    strokeWidth: 1.5,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    color: "currentColor",
    ref: svgRef
  }, props), React.createElement("g", {
    clipPath: "url(#basketball-alt_svg__clip0)",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React.createElement("path", {
    d: "M17.736 20.192c4.524-3.168 5.623-9.404 2.455-13.928C17.024 1.74 10.788.641 6.264 3.81 1.74 6.976.641 13.212 3.808 17.736c3.168 4.524 9.404 5.623 13.928 2.456zM17.736 20.192L6.264 3.809M19.577 5.473c-3.77 5.896-8.508 9.214-16.302 11.415M13.06 2.056c.413 5.24 3.392 9.494 8.646 12.35M2.293 9.595c4.783 2.18 7.761 6.434 8.647 12.349"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "basketball-alt_svg__clip0"
  }, React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
}

var ForwardRef = React.forwardRef(SvgBasketballAlt);
export default ForwardRef;